import { readAllData, STORES } from "utility"
import { getByIdOffline } from "./Get_one"
import { buildFullName } from "./queue"
import dayjs from "dayjs"

export async function getPaymentsOffline({ page = 1, limit = 20, filters }) {
  let data = await readAllData(STORES.PAYMENTS)

  data = await Promise.all(
    data.map(async (p) => {
      // 🔹 Populate consultation
      let consultation = p.consultation
      if (!consultation || typeof consultation !== "object") {
        consultation = await getByIdOffline(
          STORES.CONSULTATIONS,
          p.consultationId,
        )
      }

      // 🔹 Populate patient (depuis consultation en priorité)
      let patient = p.patient
      if (!patient || typeof patient !== "object") {
        if (consultation?.patient && typeof consultation.patient === "object") {
          patient = consultation.patient
        } else if (consultation?.patientId) {
          patient = await getByIdOffline(
            STORES.PATIENTS,
            consultation.patientId,
          )
        }
      }

      // Alignement des noms de champs : la réponse serveur peut utiliser
      // amountToPay / amountPaid / remainingAmount alors que les colonnes
      // attendent montant / payment / leftToPay.
      return {
        ...p,
        montant: p.montant ?? p.amountToPay ?? p.amount ?? 0,
        payment: p.payment ?? p.amountPaid ?? p.paid ?? 0,
        leftToPay: p.leftToPay ?? p.remainingAmount ?? p.remaining ?? 0,
        creationDate: p.creationDate ?? p.createdAt ?? p.date,
        consultation,
        patient,
        fullName: p.fullName || buildFullName(patient),
      }
    }),
  )

  // 🔍 Filtre par fullName
  if (filters.fullName) {
    const search = filters.fullName.toLowerCase()
    data = data.filter((p) => p.fullName?.toLowerCase().includes(search))
  }

  // 📅 Filtres dates
  if (filters.startDate) {
    const start = dayjs(filters.startDate).startOf("day").toDate()
    data = data.filter((c) => {
      const d = c.creationDate || c.createdAt
      return d && new Date(d) >= start
    })
  }

  if (filters.endDate) {
    const end = dayjs(filters.endDate).endOf("day").toDate()
    data = data.filter((c) => {
      const d = c.creationDate || c.createdAt
      return d && new Date(d) <= end
    })
  }

  // 📄 Pagination
  const totalItems = data.length
  const start = (page - 1) * limit

  return {
    data: data.slice(start, start + limit),
    totalItems,
  }
}
